import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/swiper/swiper-bundle.css");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/components/entities/footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/components/entities/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/core/providers/confirm-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/frontru/nesterenko/src/core/providers/store-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/core/styles/_globals.scss");
